import { createContext, useContext } from 'react';

const context = createContext(false);

export const useIsCenturionContext = () => useContext(context);

export default context;
